<template>
  <el-dialog title="选择收款信息" :visible.sync="dialogFormVisible" custom-class="fix-dialog" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div style="display: flex;">

      <div style="width: 59%;">

        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-input style="width:250px;"
                      placeholder="请输入单位/个人名称查询"
                      v-model="form.deptname"></el-input>

            <el-button type="primary" icon="el-icon-search" @click="bindGrid">搜索</el-button>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight(210)"
          size="mini"
          stripe
          border
          style="width: 100%;"
        >
          <el-table-column
            label="银行信息"
            header-align="center">
            <template slot-scope="scope">
              <div style="display: flex;">
                <div>
                  <div><span style="font-size: 14px"><b>{{scope.row.bank}}</b></span>  {{scope.row.bankname}}</div>
                  <div style="font-size: 14px"><b>{{bankaccountHandle(scope.row)}}</b></div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="所属"
            align="left"
            width="220"
            header-align="center">
            <template slot-scope="scope">
              <div style="display: flex;">
                <div>
                  <div>
                    {{scope.row.deptname}}
                  </div>
                  <div>
                    <span style="color: #9B9B9B !important;">
                      {{(scope.row.adddate || "").substr(0, 10)}}&nbsp;&nbsp;{{scope.row.uname}}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="120" header-align="center">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                style="width: 40px;margin-left: 0px;padding-left: 7px;"
                @click="handleSelect(scope.$index, scope.row)">选择
              </el-button>
              <el-button
                size="mini"
                style="width: 40px;margin-left: 0px;padding-left: 7px;"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="foot" :style="{textAlign:'center' }">
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
          <PayAccountEdit ref="DataContactEdit" @afterSave="afterSave"></PayAccountEdit>
        </div>
      </div>
      <div style="width: 38%;margin-left: 10px">

        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-size: large;font-weight: bold;">添加收款信息</span>
          </div>
          <el-form :model="formDown" ref="form1" :rules="rules">
            <el-row>
              <el-col :span="24">
                <el-form-item label="账户类型" :label-width="formLabelWidth" prop="isperson">
                  <div>
                    <el-radio v-model="formDown.isperson" label="1" border @change="selectIsPerson">
                      个人账户
                    </el-radio>
                    <el-radio v-model="formDown.isperson" label="0" border @change="selectIsPerson">
                      对公账户
                    </el-radio>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item :label="inputName" :label-width="formLabelWidth" prop="deptname">
                  <el-input v-model="formDown.deptname" :placeholder="placeholderText" auto-complete="off"
                            :required="true"
                            @keyup.enter.native="querybyDeptName"
                            @keyup.delete.native="deleteDeptName"
                            @blur="querybyDeptName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-table
              :data="downTableData"
              size="mini"
              max-height="170"
              stripe
              border
              v-if="isShowTable&&downTableData.length>0"
              style="width: 100%;margin-bottom: 20px;"
            >
              <el-table-column
                label="银行信息"
                header-align="center">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <div>
                      <div>
                        {{scope.row.bank}}
                      </div>
                      <div>
                        {{bankaccountHandle(scope.row)}}
                      </div>
                      <div>
                        <b>{{scope.row.deptname}}</b>
                        <!--<span style="color: #9B9B9B !important;">-->
                            <!--{{(scope.row.adddate || "").substr(0, 10)}}&nbsp;&nbsp;{{scope.row.uname}}-->
                          <!--</span>-->
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80" header-align="center">
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    size="mini"
                    width="100%"
                    @click="handleSelect(scope.$index, scope.row)">选择
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <!--<el-row>-->
              <!--<el-col :span="24">-->
                <!--<el-form-item label="户名" :label-width="formLabelWidth" prop="bankname">-->
                  <!--<el-input v-model="formDown.bankname" auto-complete="off" :required="true"></el-input>-->
                <!--</el-form-item>-->
              <!--</el-col>-->
            <!--</el-row>-->
            <el-row>
              <el-col :span="24">
                <el-form-item label="银行账号" :label-width="formLabelWidth" prop="bankaccount">
                  <el-input v-model="formDown.bankaccount" auto-complete="off" :required="true"
                            placeholder="请输入银行卡号" @keyup.native="bankAccountStyle"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="开户行" :label-width="formLabelWidth" prop="bank">
                  <el-input v-model="formDown.bank" auto-complete="off" :required="true"
                            placeholder="请输入开户行"  ></el-input>
                  <!--<el-select v-model="formDown.bank" filterable placeholder="请选择" ref="select"-->
                             <!--:required="true" style="width: 249px">-->
                    <!--<el-option-->
                      <!--v-for="item in bankArray"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value">-->
                      <!--<div style="display: flex">-->
                        <!--<img :src="item.icon" onerror="this.src='/static/img/bank/bank-other.svg'">{{item.label}}-->
                      <!--</div>-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="联行号"  :label-width="formLabelWidth" prop="bankname">
                  <el-input v-model="formDown.bankname" auto-complete="off" :disabled="isReadOnly" placeholder="请输入联行号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col style="text-align: center">
                <el-button  type="primary" @click="saveData">保存</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>


      </div>
    </div>


  </el-dialog>


</template>

<script>
  import {getSelListData, querybyDeptName, saveData} from '@/api/pay/payaccount';
  import PayAccountEdit from './PayAccountEdit';
  export default {
    name: 'PayAccountSel',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        loading: true,
        formLabelWidth: '80px',
        form: {
          searchdata: '',
          uguid: '',
          deptname: '',
          unitguid: ''
        },
        bankArray: [],//所有银行数组
        inputName: '单位名称',//动态改变（个人名称、单位名称）
        isShowTable: false,//表格展示
        placeholderText: '输入后可回车搜索',
        formDown: {  //表单数据
          unitguid: '',//唯一编码
          uname: '',//添加人（当前登录人）
          uguid: '',//添加人uguid(当前登录人uguid)
          isperson: '',//是否个人
          deptname: '',//单位名称
          bankaccount: '',//银行账号
          bankname:'',//联行号
          bank: '',//开户行
        },
        rules: {////////定义正则验证字段。
          // bankname: [
          //   {required: true, message: '请填写户名', trigger: 'blur'},
          // ],
          bankaccount: [
            {required: true, message: '请填写银行账号', trigger: 'blur'},
          ],
          // bankname: [
          //   {required: true, message: '请填写联行号', trigger: 'blur'},
          // ],
          bank: [
            {required: true, message: '请选择开户行', trigger: 'blur'},
          ],
          deptname: [
            {required: true, message: '请输入单位名称/个人姓名', trigger: 'blur'}
          ]
        },

        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        downTableData: []
      }
    },

    methods: {
      //银行账号处理
      bankaccountHandle(row, column) {
        let account = row.bankaccount;
        if (account == undefined) {
          return "";
        }
        return account.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
      },

      //编辑触发事件
      handleEdit(index, row) {
        this.$refs.DataContactEdit.initData(row.unitguid);
      },

      //保存数据
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            //bankaccount
            this.formDown.bankaccount = this.formDown.bankaccount.replace(/\s/g, "");
            //获取当前人
            let userInfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
            this.formDown.uname = userInfo.uname;
            this.formDown.uguid = userInfo.uguid;

            saveData(this.formDown).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.handleSelect(0,this.formDown);
                // for (let i in this.formDown) {
                //   this.formDown[i] = ''
                // }
                // this.initData();
                // this.bindGrid();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        })
      },

      //删除键触发事件
      deleteDeptName() {
        if (this.formDown.deptname.trim().length <= 0) {
          this.downTableData = [];
        }
      },

      //单位名称失去焦点时查询
      querybyDeptName() {
        //个人账户不搜索
        if (this.formDown.isperson == '1') {
          return;
        }
        //若是查到有值就显示表格，若没有就不显示
        if (this.formDown.deptname.trim().length <= 0) {
          return;
        }
        querybyDeptName({
          deptname: this.formDown.deptname,
          isperson: '0',
          offset: 0,
          limit: 5,
          isLike: 'yes'
        }).then(response => {
          this.downTableData = response.data.obj;
          this.isShowTable = true;
        }).catch((error) => {
          console.log(error)
        });
      },
      handleSelect(index, row) {
        this.$emit('select', row);
        this.dialogFormVisible = false;
      },

      bindGrid() {
        getSelListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          deptname: this.form.deptname,
          isLike: 'yes'//固定值
        }).then(response => {
          this.tableData = response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
          console.log(error)
        });
      },

      //子页面保存后触发事件
      afterSave() {
        this.bindGrid();
      },

      show() {
        for (let i in this.formDown) {
          this.formDown[i] = ''
        }
        this.initData();
        this.dialogFormVisible = true;
        this.form.deptname = '';
        this.form.unitguid = '';
        this.bindGrid()
      },
      //切换个人/单位时触发
      selectIsPerson() {
        if (this.formDown.isperson == 0) {
          this.inputName = '单位名称';
          this.placeholderText = '输入后可回车搜索';
        } else if (this.formDown.isperson == 1) {
          this.inputName = '个人姓名';
          this.placeholderText = '';
          this.isShowTable = false;
        }
      },

      //初始化使用，公共初始化部分
      initData() {
        this.inputName = '单位名称';
        this.formDown.isperson = '0';
        this.isShowTable = false;
        this.downTableData = [];
        this.placeholderText = '输入后可回车搜索';
      },

      //银行卡号格式化
      bankAccountStyle() {
        this.formDown.bankaccount = this.formDown.bankaccount.replace(/\D/g, '').replace(/....(?!$)/g, '$& ')
      },
//获取账号信息
      getBankAccountInfo(){
        return this.formDown;
      }
    },
    mounted() {
      //默认获取当前个人的
      this.bindGrid();
    },
    components: {
      PayAccountEdit,
    },


  }

</script>



// WEBPACK FOOTER //
// src/components/oa/payform/PayAccountSel.vue